import { api } from "./api";

// Distribution Kit
export const distributionKitList = async (addUrl = ``) => {
  return await api.get(`/distribution-kits?${addUrl}`);
};

export const distributionKitAdd = async (data) => {
  return await api.post(`/distribution-kits`, data);
};

export const distributionKitDetails = async (id) => {
  return await api.get(`/distribution-kits/${id}`);
};

export const distributionKitUpdate = async (id, data) => {
  return await api.post(`/distribution-kits/${id}`, data);
};

export const distributionKitDelete = async (id) => {
  return await api.post(`/distribution-kits/${id}/delete`);
};

// Distribution Kit Item (nested under a kit)
export const distributionKitItemList = async (kitId, addUrl = ``) => {
  return await api.get(`/distribution-kits/${kitId}/items?${addUrl}`);
};

export const distributionKitItemAdd = async (kitId, data) => {
  return await api.post(`/distribution-kits/${kitId}/items`, data);
};

export const distributionKitItemDetails = async (kitId, id) => {
  return await api.get(`/distribution-kits/${kitId}/items/${id}`);
};

export const distributionKitItemUpdate = async (kitId, id, data) => {
  return await api.post(`/distribution-kits/${kitId}/items/${id}`, data);
};

export const distributionKitItemDelete = async (kitId, id) => {
  return await api.post(`/distribution-kits/${kitId}/items/${id}/delete`);
};

export const distributionKitAssign = async (kitId, data) => {
  return await api.post(`/distribution-kits/${kitId}/assign`, data);
};

export const distributionKitItemAssign = async (kitId, itemId, data) => {
  return await api.post(
    `/distribution-kits/${kitId}/items/${itemId}/assign`,
    data,
  );
};

export const distributionKitAssignmentList = async (kitId, addUrl = ``) => {
  return await api.get(`/distribution-kits/${kitId}/assignments?${addUrl}`);
};

export const kitAssignmentRemove = async (id) => {
  return await api.post(`/kit-assignments/${id}/remove`);
};

export const kitAssignmentFeeList = async (addUrl = ``) => {
  return await api.get(`/kit-assignment-fees?${addUrl}`);
};

export const kitAssignmentFeePay = async (id, data) => {
  return await api.post(`/kit-assignment-fees/${id}/pay`, data);
};

export const kitAssignmentFeeDetails = async (id) => {
  return await api.get(`/kit-assignment-fees/${id}`);
};

export const kitAssignmentFeePayments = async (feeId) => {
  return await api.get(`/kit-assignment-fees/${feeId}/payments`);
};
